import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'
export default class GeoControll extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/location'
    super(store, path)
  }

  live(filter, showProgress) {
    return this._request({
      action: 'live',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
  speed(filter, showProgress) {
    return this._request({
      action: 'speed',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  trajectory(filter, showProgress) {
    return this._request({
      action: 'trajectory',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  activity(filter, showProgress) {
    return this._request({
      action: 'activity',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
